import { render } from "./AddNetworkServer.vue?vue&type=template&id=2b3150a7&ts=true"
import script from "./AddNetworkServer.vue?vue&type=script&lang=ts"
export * from "./AddNetworkServer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__